import script from "./RichContentRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./RichContentRenderer.vue?vue&type=script&setup=true&lang=js"

import "./RichContentRenderer.vue?vue&type=style&index=0&id=6769dda3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6769dda3"]])

export default __exports__